import React from 'react'
import { Badge } from 'reactstrap'
import { LinkButton } from '../../buttons'
import { withGridContext } from '../providers'
import { ContextType } from '../types/advanced-grid.types'

/**
 * Component used to render the table total records
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @returns
 */
const TotalRenderer: React.FC<ContextType> = ({
    selectedRecords,
    totalRecords,
    clearSelection
}) => {
    const handleClearAll = () => {
        if (clearSelection) clearSelection()
    }

    return (
        <>
            <Badge color="dark">{totalRecords}</Badge>
            <span className="font-bold text-xm ml-2">Records</span>
            {selectedRecords && selectedRecords?.length > 0 && (
                <>
                    <span className="ml-6 font-bold text-xm ml-2">{`(${selectedRecords.length} selected)`}</span>
                    <LinkButton onClick={handleClearAll}>clear</LinkButton>
                </>
            )}
        </>
    )
}

export default withGridContext(TotalRenderer)
